<template>
    <div>

        <div v-if="isLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h2>Door Maintenance Reports</h2>
                    </div>
                    <div class="widget-body border-bottom">
                        <router-link to="/door-maintenance-reports/add"
                                     class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3"
                                     style="display:block;width:100%">Start New Report
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3 class="d-none">
                            Door Maintenance Reports ({{ reports.length }})</h3>
                        <h3>
                            Door Maintenance Reports ({{ filteredCount }})</h3>
                    </div>
                    <div class="widget-body">
                        <div class="input-group pb-5">
                        <span class="input-group-addon pr-0 pl-0">
                        <a class="btn" href="#">
                        <i class="fa fa-search"></i>
                        </a>
                        </span>
                            <input type="text" class="form-control dynamic-search" name="search_term"
                                   v-model="search"
                                   placeholder="Search (enter at least 3 characters)">
                        </div>


                        <div class="container">

                            <door-maintenance-report
                                    v-for="report in filteredReports"
                                    v-bind:key="report.site_door_maintenance_report_id"
                                    v-bind:report="report"
                                    v-bind:reportItems="reportItems"
                            >
                            </door-maintenance-report>


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import DoorMaintenanceReport from '@/components/DoorMaintenanceReport.vue';

    export default {
        data() {
            return {
                reports: [],
                reportItems: [],
                isLoading: true,
                search: ''
            }
        },
        components: {
            DoorMaintenanceReport,
        },
        computed: {
            filteredReports() {
                if (this.reports.length > 0) {
                    return this.reports.filter(item => {
                        return (item.job_number && item.job_number.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                            || (item.prepared_for && item.prepared_for.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    });
                } else {
                    return [];
                }
            },
            filteredCount() {
                return this.filteredReports.length;
            }
        },
        mounted() {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDMR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getReports();
            this.getReportItems();
        },
        methods: {
            getReports() {
                var vmt = this;
                this.getDb(function onConnected(db) {
                    vmt.reports = [];
                    try {
                        var objectStore = db.transaction('door_maintenance_reports').objectStore('door_maintenance_reports');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                vmt.isLoading = false;
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.reports) {
                                        if (
                                            (cursor.value.is_deleted === undefined || cursor.value.is_deleted === false) &&
                                            (cursor.value.is_complete === undefined || cursor.value.is_complete === false)
                                        ) {
                                            vmt.reports.push(cursor.value)
                                        }
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                    }
                });
            },
            getReportItems() {
                var vmt = this;
                this.getDb(function onConnected(db) {
                    vmt.reportItems = [];
                    try {
                        var objectStore = db.transaction('door_maintenance_report_items').objectStore('door_maintenance_report_items');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.reportItems) {
                                        vmt.reportItems.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                    }
                });
            },
        }
    }
</script>